const list = [{
		img: require('@/assets/image/about/l-1.png'),
		name: "惠民工程",
		text: "质优价廉",
		content: "作为政府项目，长春市人才公寓项目以服务民生为己任，非盈利为目的，租金价格仅为同等条件住房租金价格的70％，其余部分财政进行补贴，有效减轻青年人才就业、创业成本。"
	},
	{
		img: require('@/assets/image/about/l-2.png'),
		name: "专业管理",
		text: "保障安全",
		content: "作为政府项目，长春市人才公寓项目以服务民生为己任，非盈利为目的，租金价格仅为同等条件住房租金价格的70％，其余部分财政进行补贴，有效减轻青年人才就业、创业成本。"
	},
	{
		img: require('@/assets/image/about/l-3.png'),
		name: "分布广泛",
		text: "配套齐全",
		content: "作为政府项目，长春市人才公寓项目以服务民生为己任，非盈利为目的，租金价格仅为同等条件住房租金价格的70％，其余部分财政进行补贴，有效减轻青年人才就业、创业成本。"
	},
	{
		img: require('@/assets/image/about/l-4.png'),
		name: "优质平台",
		text: "助力成长",
		content: "作为政府项目，长春市人才公寓项目以服务民生为己任，非盈利为目的，租金价格仅为同等条件住房租金价格的70％，其余部分财政进行补贴，有效减轻青年人才就业、创业成本。"
	},
	{
		img: require('@/assets/image/about/l-5.png'),
		name: "社交互动",
		text: "资源整合",
		content: "作为政府项目，长春市人才公寓项目以服务民生为己任，非盈利为目的，租金价格仅为同等条件住房租金价格的70％，其余部分财政进行补贴，有效减轻青年人才就业、创业成本。"
	}
]

const service = [{
		img: require('@/assets/image/about/s-1.png'),
		name: "均采用精装修",
		content: "长春市人才公寓项目定义为高品质单身公寓，每套公寓均采用精装修，采用现代、简约、实用的装修风格，以方便入住为设计主基调。室内配有电视、冰箱、洗衣机、烟机、淋浴器、卫浴、床、床垫、桌椅、衣柜等必要的家具及卫生设施，天然气、宽带、有线电视直接入户，设施设备齐全，实现拎包入住。"
	},
	{
		img: require('@/assets/image/about/s-2.png'),
		name: "统一物业管理",
		content: "人才公寓所处各小区实行统一物业管理，采取门禁刷卡进入，配套防盗门、智能锁，提供公共保安、保洁、维修、绿化以及多项有偿服务。"
	},
	{
		img: require('@/assets/image/about/s-3.png'),
		name: "成熟商业配套",
		content: "小区周边具备成熟的商业配套，根据人才公寓入住人员的特点及需求，还将引进24小时便利店、24小时自助洗衣房、自助银行、智能快递终端服务、自助式KTV、图书阅览室、咖啡吧、健身房、创业空间、会客空间等配套功能。"
	}
]

const condition = [{
		name: "高层次人才",
		text: "根据《长春市高层次人才分类目录》，经我市认定的高层次人才",
		content: [{
				left: "国内外顶尖人才",
				num: "130"
			},
			{
				left: "国家级领军人才",
				num: "130"
			},
			{
				left: "省级领军人才",
				num: "130"
			}
		]
	},
	{
		name: "产业发展急需紧缺人才",
		text: "我市相关产业、行业或岗位急需紧缺的各类专业人才",
		content: [{
				left: "正高级专业技术资格",
				num: "110-130"
			},
			{
				left: "副高级专业技术资格",
				num: "90-110"
			},
			{
				left: "中级专业技术资格",
				num: "90-110"
			},
			{
				left: "高级技师职业资格",
				num: "90-110"
			},
			{
				left: "技师职业资格",
				num: "90-110"
			}
		]
	},
	{
		name: "在企业新就业或自主创业的高校毕业生",
		text: "毕业不满3年（含3年）且在长春市市区企业就业或自主创业的全日制普通高等院校毕业",
		content: [{
				left: "博士研究生毕业生",
				num: "90-110"
			},
			{
				left: "硕士研究生毕业",
				num: "90"
			},
			{
				left: "大学本科毕业生",
				num: "90"
			}
		]
	},
]


export {
	list,
	service,
	condition
}
